import { render, staticRenderFns } from "./OrderRowInCustomer.vue?vue&type=template&id=0296a3d0&scoped=true&xmlns%3Av-slot=http%3A%2F%2Fwww.w3.org%2F1999%2FXSL%2FTransform"
import script from "./OrderRowInCustomer.vue?vue&type=script&lang=ts"
export * from "./OrderRowInCustomer.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0296a3d0",
  null
  
)

export default component.exports